import { render, staticRenderFns } from "./KYCRequestDetails.vue?vue&type=template&id=185ad672&scoped=true"
import script from "./KYCRequestDetails.vue?vue&type=script&lang=js"
export * from "./KYCRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ad672",
  null
  
)

export default component.exports